import { IconButton, Stack, useTheme } from "@mui/material";
import { ArrowLeftIcon } from "lucide-react";
import type { FC, ReactNode } from "react";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";

type Props = {
	title: string;
	onBack: () => void;
	children: ReactNode;
};

export const DocumentUploadLayout: FC<Props> = ({
	title,
	onBack,
	children,
}) => {
	const { palette, iconSize } = useTheme();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={palette.grey[50]}
			topBarBgColor={palette.background.paper}
			topBar={
				<Stack width="100%" bgcolor={palette.background.paper}>
					<MyPlannTopBarRedesign
						title={title}
						startComponent={
							<IconButton onClick={onBack}>
								<ArrowLeftIcon size={iconSize.md} color={palette.grey[900]} />
							</IconButton>
						}
					/>
				</Stack>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
